const KEY_STORAGE = 'strangers-ledger.v1.deviceKey';
const CONSENT_STORAGE = 'strangers-ledger.v1.consentAccepted';

function toHex(bytes: ArrayBuffer): string {
  return [...new Uint8Array(bytes)].map((b) => b.toString(16).padStart(2, '0')).join('');
}

function randomHex(bytes = 32): string {
  const data = new Uint8Array(bytes);
  crypto.getRandomValues(data);
  return [...data].map((b) => b.toString(16).padStart(2, '0')).join('');
}

export async function getDeviceId(): Promise<string> {
  let key = localStorage.getItem(KEY_STORAGE);
  if (!key) {
    key = randomHex();
    localStorage.setItem(KEY_STORAGE, key);
  }
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(`strangers-ledger:${key}`));
  return toHex(digest).slice(0, 48);
}

export function hasConsent(): boolean {
  return localStorage.getItem(CONSENT_STORAGE) === 'yes';
}

export function setConsent(value: boolean): void {
  if (value) localStorage.setItem(CONSENT_STORAGE, 'yes');
  else localStorage.removeItem(CONSENT_STORAGE);
}

export function resetLocalIdentity(): void {
  localStorage.removeItem(KEY_STORAGE);
  localStorage.removeItem(CONSENT_STORAGE);
}
